import { GKButton, GKModal, Grid2, Typography } from "components";
import { useMutation } from "hooks/useQueries";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { refetchQuery } from "utils/helpers";

const InvestorSettingsConfirmation = (
  props: GKModalProps & { investorData: any },
) => {
  const { open, setOpen, investorData } = props;

  const userData = useAppSelector((state) => state?.user?.userData);

  const { mutate: handlePubish, isLoading: pubishLoading } = useMutation({
    mutationKey: ["HANDLE_PUBLISH_INVESTOR_WEBSITe"],
    mutationFn: ({ id }: { id: any }) =>
      axiosInstance.post(`/company/${id}/publish_website/`),
    onSuccess: () => {
      refetchQuery("GET_INVESTOR_PROFILE");
      setOpen(false);
    },
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Publish "
      width={"30%"}
      footer={
        <GKButton
          loading={pubishLoading}
          variant={investorData?.published ? "outlined" : "contained"}
          color={investorData?.published ? "error" : "primary"}
          onClick={() => handlePubish({ id: userData?.companyId })}
        >
          {investorData?.published ? "Unpublish Website" : "Publish Website"}
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          gap={2}
        >
          <img
            src={
              investorData?.published
                ? "/Investor/risk-error.svg"
                : "/Investor/risk-success.svg"
            }
            alt=" "
            style={{
              width: 100,
            }}
          />
          <Typography fontSize={16} fontWeight={600} textAlign={"center"}>
            Are you sure you want to <br />
            {investorData?.published ? "unpublish" : "publish"} you subscription
            website ?
          </Typography>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default InvestorSettingsConfirmation;
